/**
 * خطّاف مشترك لصفحات الملخص الثلاث — يمنع تكرار منطق الجلب والتصدير
 */
import { useQuery } from "@tanstack/react-query";
import api from "../../api/client";
import type { Measure, PivotReport } from "../../types";
import type { DateRange } from "../../components/shared/DateRangeFilter";

export function useReport(path: string, range: DateRange, enabled = true, measure: Measure = "requested") {
  const valid = !!range.from && !!range.to && range.from <= range.to;

  return useQuery<PivotReport>({
    queryKey: ["report", path, range.from, range.to, measure],
    enabled:  enabled && valid,
    queryFn: () =>
      api
        .get<{ data: PivotReport }>(`${path}?from=${range.from}&to=${range.to}&measure=${measure}`)
        .then((r) => r.data.data),
  });
}

/** التصدير يمر بالمتصفح مباشرة ليحمل الكوكي ويحافظ على ترميز الملف — كل المدى دائماً */
export function exportCsv(path: string, range: DateRange, measure: Measure = "requested") {
  const base = api.defaults.baseURL ?? "";
  window.open(`${base}${path}?from=${range.from}&to=${range.to}&measure=${measure}&format=csv`, "_blank");
}
